import { render, staticRenderFns } from "./FeetViewer.vue?vue&type=template&id=cb1a3d1c&scoped=true&"
import script from "./FeetViewer.vue?vue&type=script&lang=js&"
export * from "./FeetViewer.vue?vue&type=script&lang=js&"
import style0 from "./FeetViewer.vue?vue&type=style&index=0&id=cb1a3d1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb1a3d1c",
  null
  
)

export default component.exports